module.exports = __webpack_public_path__ + "img/globalwater.9aede200.jpg";